(() => {
  const syncMenuTop = () => {
    const toolbar = document.querySelector('#header > .top-bar');
    if (!toolbar || !window.matchMedia('(max-width: 798px)').matches) return;
    document.documentElement.style.setProperty('--mobile-menu-top', `${Math.max(0, toolbar.getBoundingClientRect().bottom)}px`);
  };

  const toolbar = document.querySelector('#header > .top-bar');
  if (toolbar) new ResizeObserver(syncMenuTop).observe(toolbar);
  window.addEventListener('resize', syncMenuTop, { passive: true });
  window.visualViewport?.addEventListener('resize', syncMenuTop, { passive: true });
  document.addEventListener('shopify:section:load', syncMenuTop);
  syncMenuTop();

  document.addEventListener('click', event => {
    if (event.target.closest('#header .mobile_nav')) requestAnimationFrame(syncMenuTop);
    if (!window.matchMedia('(max-width: 798px)').matches) return;

    const row = event.target.closest('#mobile_menu > li');
    const rowLink = event.target.closest('#mobile_menu > li > a');
    const submenu = row?.querySelector(':scope > ul');
    if (submenu && (rowLink || event.target === row)) {
      // Handle the whole category row before the theme's arrow-only handler.
      event.preventDefault();
      event.stopImmediatePropagation();
      row.parentElement.querySelectorAll(':scope > li.active').forEach(item => item.classList.remove('active'));
      row.classList.add('active');
      submenu.scrollTop = 0;
      const menu = row.closest('[data-dropdown="mobile_menu"]');
      if (menu) menu.scrollTop = 0;

      const typeToggle = submenu.querySelector('[data-mobile-group-toggle]');
      const typePanel = typeToggle && document.getElementById(typeToggle.getAttribute('aria-controls'));
      if (typePanel) {
        typeToggle.setAttribute('aria-expanded', 'true');
        typePanel.hidden = false;
      }
      syncMenuTop();
      return;
    }

    const toggle = event.target.closest('#mobile_menu [data-mobile-group-toggle]');
    if (!toggle) return;
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    // Keep the theme's delegated accordion handler from toggling the same group.
    event.preventDefault();
    event.stopImmediatePropagation();
    const expanded = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
  }, true);
})();
